import { SessionState } from '../reducers/session'
import { User } from '../types'
import { getLocalStorage } from './localStorage'
import config from '../config'

// getSessionFromLocalStorage gets the session data from local storage
// and runs all validation against it, returning null if the session
// is invalid and the user needs to authentidate.
// It should be favored over calling `getLocalStorage` or interacting with local
// storage manually.
export const getSessionFromLocalStorage = (): SessionState | null => {
  const session: SessionState | null = getLocalStorage(config.sessionKey)
  if (!isSessionValid(session)) {
    return null
  }
  return session
}

export const isSessionValid = (session: SessionState | undefined | null): boolean => {
  if (!session) {
    return false
  }

  if (!isAuthTokenValid(session)) {
    return false
  }

  if (!isSessionNotExpired(session)) {
    return false
  }

  if (!isSessionUserValid(session)) {
    return false
  }

  return isSessionOrganizationValid(session)
}

export const isAuthTokenValid = (session: Partial<SessionState> | undefined | null): boolean => {
  if (!session) {
    return false
  }
  if (!session.authorizationToken) {
    return false
  }
  return session.authorizationToken !== ''
}

export const isSessionNotExpired = (session: Partial<SessionState> | undefined | null): boolean => {
  if (!session) {
    return false
  }
  if (!session.authorizationTokenExpiration) {
    return false
  }
  return new Date(session.authorizationTokenExpiration) > new Date()
}

export const isSessionUserValid = (session: Partial<SessionState> | undefined | null): boolean => {
  if (!session) {
    return false
  }
  const user = session.user
  if (!user || !user.ID) {
    return false
  }
  return user.ID !== ''
}

export const isSessionOrganizationValid = (session: Partial<SessionState> | undefined | null): boolean => {
  if (!session) {
    return false
  }
  const org = session.organization
  if (!org || !org.ID) {
    return false
  }
  return org.ID !== ''
}

export const getUserThemeFromSession = (session: Partial<SessionState> | undefined | null): string | undefined => {
  if (!session || !session.user) {
    return
  }
  const theme = (session.user as Partial<User>).theme
  if (!theme) {
    return
  }
  if (theme !== 'dark' && theme !== 'light') {
    return
  }

  return theme
}
